import { useState } from 'react'
import { Link } from 'react-router-dom'
import { RiAddLine, RiSubtractLine } from 'react-icons/ri'
import SEO from '../../components/seo/SEO'
import { breadcrumb, faq as faqLd } from '../../components/seo/jsonLd'

const FAQS = [
  {
    q: 'How do I book an appointment?',
    a: 'You can book online via the "Book" button at any time, or call us at +91 98765 43210. Online bookings are confirmed instantly with an SMS and email.',
  },
  {
    q: 'Can I choose my preferred stylist?',
    a: 'Yes. While booking online, the "Pick a stylist" step lets you choose any of our specialists based on speciality, ratings and availability.',
  },
  {
    q: 'What is your cancellation policy?',
    a: 'You can cancel or reschedule for free up to 4 hours before your slot. Cancellations within 4 hours forfeit any deposit paid.',
  },
  {
    q: 'Do you accept walk-ins?',
    a: 'We try to accommodate walk-ins whenever possible, but appointments always take priority. Booking ahead is strongly recommended on weekends.',
  },
  {
    q: 'Which products do you use?',
    a: 'We use professional, salon-grade brands like L\'Oréal Professionnel, Kérastase, Wella, OPI and Dermalogica. We are also paraben/ammonia-free on request.',
  },
  {
    q: 'Do you offer bridal services on-location?',
    a: 'Yes. Our bridal team travels across Chennai and Tamil Nadu. On-location surcharges depend on distance and team size.',
  },
  {
    q: 'Are gift cards available?',
    a: 'Absolutely. Digital gift cards starting at ₹1,000 can be purchased at the front desk or by emailing hello@salonvora.com.',
  },
  {
    q: 'Is parking available?',
    a: 'Yes, complimentary valet parking is available for all guests at our Anna Nagar studio.',
  },
  {
    q: 'Do you do patch tests for colour services?',
    a: 'Yes, we recommend a patch test 48 hours before any new colour or chemical service. It is free and takes only 5 minutes.',
  },
  {
    q: 'What hygiene practices do you follow?',
    a: 'All tools are sterilised between clients, single-use disposables are used wherever possible, and our salon is sanitised every 2 hours.',
  },
]

export default function FAQ() {
  const [open, setOpen] = useState(0)

  return (
    <>
      <SEO
        title="Frequently Asked Questions"
        description="Everything you need to know about booking, products, hygiene, bridal services and policies at Salon Vora."
        path="/faq"
        jsonLd={[
          breadcrumb([{ name: 'Home', url: '/' }, { name: 'FAQs', url: '/faq' }]),
          faqLd(FAQS.map((f) => ({ question: f.q, answer: f.a }))),
        ]}
      />

      <div className="min-h-screen bg-salon-cream">
        <section className="relative bg-hero-gradient py-28 text-center overflow-hidden">
          <div className="container-salon relative z-10">
            <span className="section-tag mb-4 inline-block !text-salon-secondary !bg-salon-secondary/15">Help Centre</span>
            <h1 className="font-display text-4xl md:text-6xl font-bold text-white mb-3">
              Frequently Asked <span className="text-salon-secondary italic">Questions</span>
            </h1>
            <p className="text-white/70 font-body max-w-xl mx-auto">
              Can't find what you're looking for? <Link to="/contact" className="underline text-salon-secondary">Get in touch</Link>.
            </p>
          </div>
        </section>

        <section className="py-20">
          <div className="container-salon max-w-3xl">
            <div className="space-y-3">
              {FAQS.map((f, i) => {
                const isOpen = open === i
                return (
                  <div key={f.q}
                    className={`rounded-2xl border bg-white transition-colors ${isOpen ? 'border-salon-primary shadow-salon-sm' : 'border-salon-cream-dark'}`}>
                    <button
                      onClick={() => setOpen(isOpen ? -1 : i)}
                      className="w-full flex items-center justify-between text-left px-6 py-5 gap-4"
                      aria-expanded={isOpen}
                    >
                      <span className="font-display font-semibold text-salon-dark text-base sm:text-lg">{f.q}</span>
                      <span className={`shrink-0 w-8 h-8 rounded-full flex items-center justify-center transition-colors
                                        ${isOpen ? 'bg-salon-primary text-white' : 'bg-salon-cream text-salon-primary'}`}>
                        {isOpen ? <RiSubtractLine /> : <RiAddLine />}
                      </span>
                    </button>
                    {isOpen && (
                      <div className="px-6 pb-5 text-salon-muted font-body leading-relaxed">{f.a}</div>
                    )}
                  </div>
                )
              })}
            </div>
          </div>
        </section>
      </div>
    </>
  )
}
